export default __webpack_public_path__ + "static/media/arrow.ca8889da.svg";